import { cn, io } from 'lib/helpers/utility';

import DisplayButtonAGTable from 'components/shared/AGTable/components/DisplayButtonAGTable/DisplayButtonAGTable';
import Filters from 'components/shared/Filters/Filters';
import FilterActions from 'components/shared/Filters/components/FilterActions';

const TableFilters = ({
  filters,
  initialFilters,
  changeFilters,
  updateFilters,
  category,
  defaultFilters,
  isEditingFilter,
  className = '',
  disableActions = false,
  items = [],
  type,
  noDisplayButton = false,
  noFilterActions = false,
  modalView
}) => {
  if (!io(defaultFilters) && noDisplayButton && !io(filters)) {
    return null;
  }

  return (
    <div
      className={cn(
        'outline-b flex items-start justify-between gap-2 bg-white px-4 py-2 outline-1 outline-offset-[-1px] outline-neutral-200',
        className
      )}>
      {io(defaultFilters) ? (
        <Filters
          defaultFilters={defaultFilters}
          filters={filters}
          changeFilters={changeFilters}
          updateFilters={updateFilters}
        />
      ) : (
        <div />
      )}
      <div className="flex flex-wrap items-start justify-end gap-2">
        {!noDisplayButton && <DisplayButtonAGTable />}
        {!noFilterActions && filters && (
          <FilterActions
            filters={filters}
            initialFilters={initialFilters}
            changeFilters={changeFilters}
            category={category}
            isEditingFilter={isEditingFilter}
            disableActions={disableActions || modalView}
            items={items}
            type={type}
          />
        )}
      </div>
    </div>
  );
};

export default TableFilters;
